import Resource from '@/api/resources/Resource'

const componentCodes = [
    'uicomponent.dashboard',
    'uicomponent.petitioner.requestpanel',
    'uicomponent.petitioner.requestgrid',
    'uicomponent.petitioner.patientgrid',
    'uicomponent.registry.requestgrid',
    'uicomponent.registry.requestpanel',
    'uicomponent.registry.casepanel',
    'uicomponent.grossing.samplegrid',
    'uicomponent.grossing.portiongrid',
    'uicomponent.grossing.samplepanel',
    'uicomponent.registry.patientcasegrid',
    'uicomponent.registry.fixsampleattributes',
    'uicomponent.registry.casegrid',
    'uicomponent.registry.casesamplesgrid',
    'uicomponent.incidents.incidentgrid',
    'uicomponent.incidents.incidentpanel',
    'uicomponent.registry.modalconfig',
    'uicomponent.laboratory.sidepanel',
    'uicomponent.laboratory.sidepanel.lock',
    'uicomponent.diagnosis.casegrid',
    'uicomponent.diagnosis.modalconfig',
    'uicomponent.diagnosis.samplegrid',
    'uicomponent.diagnosis.casepanel',
    'uicomponent.waste.samplegrid',
    'uicomponent.waste.samplepanel'
]

export default class UiResource extends Resource {
    validateCode(componentCode) {
        if (!componentCodes.includes(componentCode)) {
            throw new Error(`component code ${componentCode} does not exist`)
        }
    }
}
